import { Box, Skeleton, Stack, useTheme, styled } from "@mui/material";
import { FC } from "react";

const CardHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.myTheme.colors.gray300,
  borderTopLeftRadius: "16px",
  borderTopRightRadius: "16px",
  padding: "16px 16px 8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: "44px",
}));

const CardBody = styled(Box)(({ theme }) => ({
  backgroundColor: theme.myTheme.colors.gray400,
  borderBottomLeftRadius: "16px",
  borderBottomRightRadius: "16px",
  padding: "16px 16px 8px",
}));

const HeaderSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.myTheme.colors.gray400,
}));

const BodyTextSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.myTheme.colors.gray500,
  transform: "scale(1, 1)",
}));

const CircularSkeleton = styled(Skeleton)(({ theme }) => ({
  backgroundColor: theme.myTheme.colors.gray500,
}));

const RowContainer = styled(Stack)({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "16px",
});

const IconsGroup = styled(Stack)({
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
});

interface CardSkeletonProps {
  bodyHeight: string;
}

const CardSkeleton: FC<CardSkeletonProps> = ({ bodyHeight }) => {
  return (
    <Box width="100%">
      <CardHeader>
        <HeaderSkeleton height="18px" width="80px" variant="text" />
        <HeaderSkeleton height="20px" width="80px" variant="text" />
      </CardHeader>

      <CardBody height={bodyHeight}>
        <RowContainer>
          <IconsGroup>
            <CircularSkeleton height="28px" width="28px" variant="circular" />
            <CircularSkeleton height="28px" width="28px" variant="circular" />
            <BodyTextSkeleton height="20px" width="140px" variant="text" sx={{ ml: "4px" }} />
          </IconsGroup>
          <BodyTextSkeleton height="20px" width="55px" variant="text" />
        </RowContainer>

        <BodyTextSkeleton height="50px" variant="text" sx={{ mb: "32px" }} />

        <RowContainer>
          <BodyTextSkeleton height="20px" width="100px" variant="text" />
          <BodyTextSkeleton height="20px" width="100px" variant="text" />
        </RowContainer>

        <RowContainer>
          <BodyTextSkeleton height="20px" width="120px" variant="text" />
          <BodyTextSkeleton height="20px" width="130px" variant="text" />
        </RowContainer>

        <RowContainer>
          <BodyTextSkeleton height="20px" width="90px" variant="text" />
          <BodyTextSkeleton height="20px" width="100px" variant="text" />
        </RowContainer>

        <RowContainer>
          <BodyTextSkeleton height="20px" width="100px" variant="text" />
          <BodyTextSkeleton height="20px" width="100px" variant="text" />
        </RowContainer>
      </CardBody>
    </Box>
  );
};

export default CardSkeleton;
